<template>
  <div class="col-lg-12" >
    Processing...
    <img :src="logoutUrl">
  </div>
</template>

<script>
  import adfsCommon from '../../common/adfsCommon'
  import * as CONFIG from '../../config/index'
  import azureCommon from '../../common/azureCommon'
  export default {
    name: 'ProcessLogout',
    data() {
      return {
        logoutUrl: `${CONFIG.LOGOUT_URL}`
      };
    },
    methods: {
      logout: async function () {
        this.$cookies.remove('username');
        this.$cookies.remove('accessToken');
        this.$cookies.remove('roles');
        this.$cookies.remove('crowd.token_key');
        this.$cookies.remove('crowd.token_key.old');
        this.$cookies.remove('fsuBuAdmin');
        this.$cookies.remove('accountCustomerAdmin');
        this.$cookies.remove('userEmail');
        this.$cookies.remove('globalRoles');
        this.$cookies.remove('company');     
        window.localStorage.removeItem('permissions');
        //this.$router.push({name: 'LoginPage'});
        window.location.href = CONFIG.LOGOUT_URL;
      },


    },
    async mounted () {
      await this.logout();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/ProcessLogout.vue